const capitalizeFirstLetter = (value: string) => {
  const res = value.toLowerCase()
  return res.charAt(0).toUpperCase() + res.slice(1)
}

const textCopy = async (value: string) => {
  await navigator.clipboard.writeText(value)
}

export interface ITokenName {
  str: string
  isEmoji: boolean
}

const separateEmoji = (name: string) => {
  if (!name) {
    return []
  }
  const emojiRegex = new RegExp(/\p{Extended_Pictographic}/, 'gu')
  const emojiList = name.match(emojiRegex) || []
  return name.split(emojiRegex).reduce((acc, cur, index) => {
    acc.push({
      str: cur,
      isEmoji: false
    })
    if (emojiList.length > 0) {
      acc.push({
        str: emojiList[index] as string,
        isEmoji: true
      })
    }
    return acc
  }, [] as Array<ITokenName>)
}

export const capitalizeFirstLetterWithDelimiter = (str: string, delimiter: string, separator = ' ') => {
  return str.split(delimiter).map(word => capitalizeFirstLetter(word)).join(separator)
}

export const shortenAddress = (hash?: string): string => {
  if(typeof hash !== 'string') return ''
  if (!hash) return ''
  if (hash.length <= 10) {
    return hash // 해시가 너무 짧으면 축약하지 않음
  }
  return `${hash.slice(0, 6)}...${hash.slice(-4)}`
}

export const isCollectionNameMaplestoryCharacter = (name: string): boolean => {
  return name === 'MaplestoryCharacter'
}

export { capitalizeFirstLetter, separateEmoji, textCopy }